/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import MallPopup from './MallPopup';
import NumEdit from './NumEdit';
import TransferDom from "vux/src/directives/transfer-dom/index.js";
import Checker from "vux/src/components/checker/checker.vue";
import CheckerItem from "vux/src/components/checker/checker-item.vue";
export default {
  components: {
    Checker: Checker,
    CheckerItem: CheckerItem,
    TransferDom: TransferDom,
    MallPopup: MallPopup,
    NumEdit: NumEdit // Popover

  },
  directives: {
    TransferDom: TransferDom
  },
  props: {
    filterList: Array,
    active: {
      type: Boolean,
      "default": false
    },
    goodsName: String,
    type: {
      type: Number,
      "default": 0
    },
    nowId: ''
  },
  data: function data() {
    return {
      show: this.active,
      bottom: 0,
      canMinus: true,
      canPlus: true,
      selectedFilter: "",
      beforeFilter: '',
      goodsNum: 1
    };
  },
  watch: {
    active: function active(newVal) {
      this.show = newVal;
    },
    show: function show(val) {
      this.$emit('setShow', val);

      if (val) {
        this.$bus.$emit('unique-show', this);
      }
    },
    nowId: function nowId(val) {
      if (val) {
        this.selectedFilter = this.nowId;
      }
    },
    selectedFilter: function selectedFilter(val, oldVal) {
      this.beforeFilter = oldVal;
    }
  },
  computed: {
    inventory: function inventory() {
      var _this = this;

      var nowItem = this.filterList.find(function (x) {
        return x.goodsDetailId == _this.selectedFilter;
      });

      if (nowItem) {
        return nowItem.inventory;
      }

      return '';
    }
  },
  created: function created() {
    var _this2 = this;

    console.log(this.filterList);

    if (this.nowId) {
      this.selectedFilter = this.nowId;
    }

    this.$bus.$on('unique-show', function (target) {
      if (target !== _this2) {
        _this2.show = false;
      }
    });
  },
  mounted: function mounted() {
    var parentTop = this.$el.parentNode.offsetTop;
    var parentHeight = this.$el.parentNode.offsetHeight;
    this.top = parentTop + parentHeight + 'px'; // this.top = parentTop+this.$el.offsetTop + this.$el.offsetHeight + 'px'
  },
  methods: {
    backClick: function backClick(e) {
      console.log('back', e);
    },
    confirmEvent: function confirmEvent() {
      this.show = false;
      var result = {};
      result.goodsDetailId = this.selectedFilter;
      result.num = this.goodsNum;
      result.type = this.type;
      result.goodsDetailIdBefore = this.beforeFilter;
      this.$emit('filterConfirm', result);
    },
    getNum: function getNum(val) {
      this.goodsNum = val[0];
    },
    //check变化
    itemChange: function itemChange() {
      var result = {};
      result.goodsDetailId = this.selectedFilter;
      result.type = this.type;
      this.$emit('specChange', result);
    }
  }
};